/* Blog CTA click tracking -- the storefront half.
 *
 * Shopify Custom Pixels run inside a sandboxed iframe
 * (id="web-pixel-sandbox-CUSTOM-...-LAX-...", sandbox="allow-scripts allow-forms")
 * and cannot reach the storefront DOM. So the click has to be detected here,
 * in the theme, and republished as a custom analytics event. The pixel half
 * picks it up with analytics.subscribe('blog_cta_click', ...).
 *
 * gtag is fired directly too, so GA4 still records the click even if the
 * pixel is disconnected.
 */
(function () {
  'use strict';

  function onClick(event) {
    var link = event.target && event.target.closest
      ? event.target.closest('a[data-rom-cta-target]')
      : null;
    if (!link) return;

    var wrap = link.closest('[data-rom-cta]');
    var payload = {
      slot: (wrap && wrap.getAttribute('data-rom-cta')) || '',
      target: link.getAttribute('data-rom-cta-target') || '',
      article: (wrap && wrap.getAttribute('data-rom-cta-article')) || '',
      href: link.getAttribute('href') || ''
    };

    // Shopify's event stream -> the custom pixel subscribes to this.
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('blog_cta_click', payload);
      }
    } catch (e) {}

    // Direct to GA4 as well, so tracking survives the pixel being off.
    try {
      if (window.gtag) window.gtag('event', 'blog_cta_click', payload);
    } catch (e) {}
  }

  // Capture phase: the handler must run before navigation starts.
  document.addEventListener('click', onClick, true);
})();
